'use strict';

module.exports = paragraph;

function paragraph(node) {
  return this.all(node).join('');
}



//////////////////
// WEBPACK FOOTER
// ./~/remark/~/remark-stringify/lib/visitors/paragraph.js
// module id = 307
// module chunks = 96961042003272 139266963665775